import { InjectionToken } from '@angular/core';
import { LoggingConfig } from './logging.model';

export const MAX_LOG_ENTRIES = 50;

export const STORAGE_KEY = 'mdla-logs';

export const LOGGING_CONFIG = new InjectionToken<LoggingConfig>('LOGGING_CONFIG');
